import React, { Component } from 'react'
import { connect } from 'shalala';
import { Route } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../../store';
import CatalogoClienteUpload from './CatalogoClienteUpload';
import CatalogoClienteList from './list/CatalogoClienteList';
import SearchByDatesAndKeyword from '../../../shared/SearchByDatesAndKeyword';
import CatalogoClienteListActions from './list/components/CatalogoClienteListActions';
import CatalogoClienteItemActions from './list/components/CatalogoClienteItemActions';

class CatalogoClienteFiles extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Catálogo Cliente');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/modulos/catalogo-cliente/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to } = this.props.pagination;

    return (
      <>
        <Row>
          <Col sm="auto" md="8" className="mb-2">
            { selectedRowKeys.length > 0 && (
              <div className="mr-3 d-inline-flex pb-2">
                <CatalogoClienteItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                  alignRight={ false }
                />
              </div>
            )}

            { selectedRowKeys.length === 0 && (
                <SearchByDatesAndKeyword
                  from={ from }
                  to={ to }
                  onDateChange={ this.handleOnDateChange }
                  onKeywordChange={ this.handleOnKeywordChange }
                />
              )}
          </Col>

          <Col sm="auto" md="4" className="text-right pb-2">
            <CatalogoClienteListActions />
          </Col>
        </Row>

        { Guardian.allows('catalogo.cliente.listar.archivos') && (
          <CatalogoClienteList
            onRowClick={ this.handleOnRowClick }
            selectedRowKeys={ selectedRowKeys }
            selectedRows={ selectedRows }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}

        <Route path="/modulos/catalogo-cliente/archivos/upload" component={ CatalogoClienteUpload } />
      </>
    )
  }
}

const mapState = (store) => {
  return store.modulo.catalogo.cliente.archivos
}

const mapActions = (actions) => {
  return actions.modulo.catalogo.cliente.archivos;
}

export default connect(useStore, mapState, mapActions)(CatalogoClienteFiles);